/**
 * We want to limit imports directly from `launchdarkly-react-client-sdk` to prevent
 * untyped feature flag usage
 */
// eslint-disable-next-line no-restricted-imports
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';

import { isDefined, useLoggedInAuthContext } from 'common';

export function useLaunchDarklyIdentifyEffect() {
  const { user, defaultOrganization } = useLoggedInAuthContext();
  const ldClient = useLDClient();
  useEffect(() => {
    void ldClient?.identify({
      /**
       * If this code is used in a patient facing app, DO NOT include PHI or PII, such as email,
       * address, zip code, or health data
       */
      kind: 'user',
      key: user.id,
      email: user.email,
      anonymous: !isDefined(user),
      firstName: user.firstName,
      lastName: user.lastName,
      custom: {
        /**
         * If this code is used in a patient facing app, DO NOT include PHI or PII, such as email,
         * address, zip code, or health data
         */
        role: user?.role,
        defaultOrganization: {
          id: defaultOrganization?.id,
          name: defaultOrganization?.name,
        },
      },
    });
  }, [ldClient, user, defaultOrganization]);
}
